const isRangeSearchParam = (paramKey: string): boolean => {
    const rangeRegex = /__start$|__end$/;
    return rangeRegex.test(paramKey);
};

export default isRangeSearchParam;
